// This file contains the logic derived from the Data Sharing Rights Excel sheet.
// It matches layer names/paths to attribution and restricted status.

const restrictedRules = [
  {
    // /GSH 4/TRIQUETRA/.../Smuszewo/Archaeological_data/Smuszewo_geophysical_survey
    keywords: ["Smuszewo", "geophysical"],
    attribution: "Data provided by AMU",
  },
  {
    // /GSH 4/TRIQUETRA/.../Smuszewo/Geo-Environmental Data/Hydrology/BATHYMETRY
    keywords: ["Smuszewo", "Hydrology"],
    attribution: "Data provided by AMU",
  },
  {
    // /GSH 4/TRIQUETRA/.../Smuszewo/Archaeological_data/Smuszewo_GIS
    keywords: ["Smuszewo", "GIS"],
    attribution: "Attribution for data retrieved from publication",
  },
  {
    // /GSH 4/TRIQUETRA/.../Roseninsel/Archaeological_data/Roseninsel_GIS
    keywords: ["Roseninsel", "GIS"],
    attribution: "Attribution for data retrieved from publication",
  },
  {
    // /GSH 4/TRIQUETRA/.../Les_Argilliez/Archaeological_data/Les_Argilliez_GIS
    keywords: ["Les_Argilliez", "GIS"],
    attribution: "Attribution for data retrieved from publication",
  },
  {
    // /GSH 4/TRIQUETRA/.../Kalapodi/Archaeological_data/Kalapodi_GIS
    keywords: ["Kalapodi", "GIS"],
    attribution: "Attribution for data retrieved from publication",
  },
  {
    // /GSH 4/TRIQUETRA/.../Choirokitia/Archaeological_data/Choirokoitia_GIS
    keywords: ["Choirokoitia", "GIS"],
    attribution:
      "Attribution for data retrieved from publication. The 3D data from ECOE has copyright ECOE.",
  },
];

/**
 * Checks if a layer is restricted based on its name and parent group.
 * Returns an object with isRestricted (bool) and attribution (string).
 */
export const getRestrictedInfo = (layerName, groupContext = "") => {
  // Normalize strings for comparison (remove spaces, lowercase)
  const normalizedLayer = layerName.toLowerCase();
  const normalizedGroup = groupContext.toLowerCase();
  const fullContext = `${normalizedGroup}/${normalizedLayer}`;

  for (const rule of restrictedRules) {
    // Check if ALL keywords in a rule are present in the full context string
    const match = rule.keywords.every((keyword) =>
      fullContext.includes(keyword.toLowerCase())
    );

    if (match) {
      return { isRestricted: true, attribution: rule.attribution };
    }
  }

  return { isRestricted: false, attribution: "" };
};